import { FirebaseApp, initializeApp } from 'firebase/app';
import { Auth, getAuth } from 'firebase/auth';
import { RemoteConfig, getRemoteConfig } from 'firebase/remote-config';

const firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG || '{}');

class Firebase {
  firebase: FirebaseApp;
  auth: Auth;
  config: RemoteConfig;

  constructor() {
    const firebase = initializeApp(firebaseConfig);
    const auth = getAuth(firebase);
    const config = getRemoteConfig(firebase);

    this.firebase = firebase;
    this.auth = auth;
    this.config = config;
  }

  getAuth = () => this.auth;
  getRemoteConfig = () => this.config;
  getFirebase = () => this.firebase;
}

export default Firebase;
